import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ResetPassword.css';
import { API_BASE_URL } from '../config/apiConfig';

function ResetPassword() {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setMessage('❌ Invalid or missing token.');
    }
  }, [token]);

  const handleReset = async e => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage("❌ Passwords don't match.");
      return;
    }

    if (newPassword.length < 8) {
      setMessage('❌ Password must be at least 8 characters.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({newPassword })
      });

      const data = await res.json();
      setMessage(data.message || 'Failed to reset password');

      if (res.ok) {
        setTimeout(() => navigate('/admin/login'), 3000);
      }
    } catch {
      setMessage('❌ Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="reset-password-form" onSubmit={handleReset}>
      <h2>🔐 Reset Your Password</h2>

      <input
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
        required
        autoFocus
      />

      <input
        type="password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        required
      />

      <button type="submit" disabled={loading || !token}>
        {loading ? 'Resetting...' : 'Reset Password'}
      </button>

      {message && <p className="reset-message">{message}</p>}
    </form>
  );
}

export default ResetPassword;
